export function compareString(str1: string, str2: string) {
    return str1?.toLowerCase() === str2?.toLocaleLowerCase();
}
